import React, { useState } from 'react';
import { getMemberSince } from '../Common/AllDateTimeReleventFormate';
import { useNavigate } from 'react-router-dom';

export default function DashboardHorizontalChart({ milestones }) {
  const laung = localStorage.getItem("laung");
  const [lan] = useState(laung ?? "en");
  const navigate = useNavigate();

  const [visibleCount, setVisibleCount] = useState(4);
  const backgroundColors = ['#FFF2E7'];

  const handleShowMore = () => setVisibleCount((prev) => prev + 4);
  const handleShowLess = () => setVisibleCount(4);

  return (
    <div className="earning-wrapper h-100">
      <h6>Due Today Milestones</h6>

      {Array.isArray(milestones) && milestones.length > 0 ? (
        <div>
          {milestones.slice(0, visibleCount).map((item, index) => (
            <div
              key={index}
              onClick={() =>
                navigate(`/${lan}/dashboard/myorders/project/completed/${item?.post_id}`)
              }
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                padding: '20px 30px',
                marginTop: 10,
                borderBottom: '1px solid #ddd',
                background: backgroundColors[index % backgroundColors.length],
                borderRadius: 25,
                cursor: 'pointer',
              }}
            >
              <p style={{ color: '#666', margin: 0, width: '20%' }}>
                {getMemberSince(item?.ends_on)}
              </p>
              <div style={{ paddingLeft: 50 }}>
                <p style={{ fontWeight: 'bold', margin: 0 }}>
                  Project: {item?.post_title}
                </p>
                <p style={{ fontWeight: 'bold', margin: 0 }}>
                  Milestone: {item?.title}
                </p>
              </div>
            </div>
          ))}

          {/* Toggle buttons */}
          {milestones.length > 4 && (
            <div
              onClick={
                visibleCount < milestones.length ? handleShowMore : handleShowLess
              }
              style={{
                color: '#007bff',
                cursor: 'pointer',
                padding: '10px',
                textAlign: 'center',
                marginTop: '10px',
                fontWeight: 'bold',
              }}
            >
              {visibleCount < milestones.length ? 'View More' : 'View Less'}
            </div>
          )}
        </div>
      ) : (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{
            padding: 50,
            marginTop: 10,
            width: '100%',
            background: '#F3F3F3',
            borderRadius: 24,
            height: '88%',
          }}
        >
          <p className="text-center">No Milestones Found</p>
        </div>
      )}
    </div>
  );
}
